// extracted by mini-css-extract-plugin
module.exports = {"qrButton":"DownloadTanksQr_qrButton__3Hwzs","mapPin":"DownloadTanksQr_mapPin__3BnjL"};